import React from "react";
import { Button, Breadcrumb, Container, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCog, faSync } from "@fortawesome/free-solid-svg-icons";

const getViewDetails = (view, platform, isExistingEvent) => {
  if (view === "reports") {
    return {
      label: "Relatórios",
      description: "Consulte os dados coletados durante o evento",
    };
  }

  if (view === "records") {
    return {
      label: "Registros",
      description: Number(platform) === 2 ? "Consulte cadastros, respostas RSVP e check-ins do evento" : "Consulte e gerencie inscrições, check-ins e participantes do evento",
    };
  }

  if (view === "emails") {
    return {
      label: "E-mails",
      description:
        "Com o sistema de e-mails você pode enviar e-mails para os participantes do evento",
    };
  }

  if (view === "communications") {
    return {
      label: "WhatsApp",
      description:
        "Gerencie as mensagens, campanhas e bloqueios de WhatsApp do evento",
    };
  }

  if (view === "logs") {
    return {
      label: "Logs",
      description: "Status dos Logs de ações e erros",
    };
  }

  return {
    label: isExistingEvent ? "Editar evento" : "Novo evento",
    description:
      platform === 1
        ? "Configure seu evento, desenvolva sua identidade visual e adicione aplicativos."
        : "Configure seu evento, desenvolva sua identidade visual e escolha as funcionalidades desejadas.",
  };
};

export const EventEditHeader = ({
  dataTable,
  platform,
  view,
  canManageCurrentEvent,
  canViewEmails = false,
  canViewCommunicationChannels = false,
  canViewLogs = false,
  onGoToEvents,
  onGoToEdit,
  onShowHistory,
  onShowRecords,
  onShowEmails,
  onShowCommunicationChannels,
  onShowLogs,
  onRefresh,
}) => {
  const isSubpage = view !== "edit";
  // Event status is a user-facing string in the Plataforma Eventos payload
  // (for example, "Em andamento"). Use the persisted event identifier to
  // distinguish an existing event from a new draft instead of coercing that
  // label to a number.
  const eventIdentifier = dataTable?.evento_id ?? dataTable?.event_id ?? dataTable?.id;
  const isExistingEvent = Number(eventIdentifier) > 0;
  const viewDetails = getViewDetails(view, platform, isExistingEvent);
  const navigationItems = [
    { label: "Registros", visible: platform === 2 && view !== "records", onClick: onShowRecords },
    { label: "Relatórios", visible: view !== "reports", onClick: onShowHistory },
    { label: "E-mails", visible: canViewEmails && view !== "emails", onClick: onShowEmails },
    { label: "WhatsApp", visible: canViewCommunicationChannels && view !== "communications", onClick: onShowCommunicationChannels },
    {
      label: "Logs",
      visible: canViewLogs && view !== "logs",
      onClick: onShowLogs,
    },
  ].filter((item) => item.visible && item.onClick);

  const handleBack = () => {
    if (view === "edit" || !canManageCurrentEvent) {
      onGoToEvents();
      return;
    }

    onGoToEdit();
  };

  return (
    <Container fluid={isSubpage} className="p-0">
      {isSubpage && onRefresh && (
        <Button
          type="button"
          variant="primary"
          className="btn update-side-panel-button"
          onClick={onRefresh}
          title="Atualizar dados"
          aria-label="Atualizar dados"
        >
          <FontAwesomeIcon icon={faSync} size="lg" />
        </Button>
      )}

      <div className="mb-3">
        {navigationItems.length > 0 && (
          <Dropdown className="d-inline float-end">
            <Dropdown.Toggle
              className="btn-primary"
              title="Seções do evento"
              aria-label="Abrir seções do evento"
            >
              <FontAwesomeIcon icon={faCog} />
              <span className="ms-2">Seções</span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {navigationItems.map((item) => (
                <Dropdown.Item key={item.label} onClick={item.onClick}>
                  {item.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}

        <Button
          variant="primary"
          className="float-end me-2"
          onClick={handleBack}
        >
          <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
          Voltar
        </Button>

        <Breadcrumb>
          <Breadcrumb.Item onClick={onGoToEvents}>Eventos</Breadcrumb.Item>
          {canManageCurrentEvent && view !== "edit" && (
            <Breadcrumb.Item onClick={onGoToEdit}>Editar evento</Breadcrumb.Item>
          )}
          <Breadcrumb.Item active>{viewDetails.label}</Breadcrumb.Item>
        </Breadcrumb>

        <h6 className={`text-muted ${isSubpage ? "mb-0" : "mb-3"}`}>
          {viewDetails.description}
        </h6>
      </div>
    </Container>
  );
};
